/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, HStack, Image, VStack } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { Label } from '../atoms/Label';
import ArrowRight from '../../assets/ArrowRight.svg?react';
import ArrowLeft from '../../assets/ArrowLeft.svg?react';
import { ButtonLabel } from '../atoms/ButtonLabel';
import './Carousel.css'; // Import the CSS file
import { useNavigate } from 'react-router-dom';
import { IBanner } from '@/service/types';
import { useTheme } from '@/contexts/ThemeProvider';

interface BannerCarouselProps {
  banners: any[];
  title?: string;
  renderItem: (banner: any, isNative?: boolean) => React.ReactNode;
}

export function BannerItem({ banner, isNative }: { banner: IBanner; isNative?: boolean }) {
  const navigate = useNavigate();
  const { slug } = useTheme();

  return (
    <Box
      cursor={'pointer'}
      onClick={() => {

        try {
          const resolvedUrl = new URL(banner.url, window.location.origin);
          const internalHost = `${slug}.partiu.com.br`;
          const isInternal = resolvedUrl.hostname === internalHost;

          if (isInternal) {
            const internalPath = `${resolvedUrl.pathname}${resolvedUrl.search}${resolvedUrl.hash}` || '/';
            navigate(internalPath);
          } else {
            window.open(resolvedUrl.toString(), '_blank');
          }
        } catch (_) {
          // Fallback for relative paths without protocol/host
          if (banner.url.startsWith('/')) {
            navigate(banner.url);
          } else {
            navigate(`/${banner.url}`);
          }
        }
      }}
    >
      <Box display={{ base: 'initial', lg: 'none' }}>
        {banner.imageMobile && banner.imageMobile.trim() !== '' && (
          <Image
            height={isNative ? 120 : 219}
            width={'100%'}
            objectFit={'cover'}
            borderRadius={24}
            src={banner.imageMobile}
          />
        )}
      </Box>
      <Box borderRadius={24} display={{ base: 'none', lg: 'initial' }}>
        {((banner.image && banner.image.trim() !== '') || (banner.imageMobile && banner.imageMobile.trim() !== '')) && (
          <Image
            objectFit={'cover'}
            borderRadius={24}
            width={'100%'}
            height={270}
            src={banner.image || banner.imageMobile}
          />
        )}
      </Box>
    </Box>
  );
}

export function BannerCarousel({ banners, title, isNative }: { banners: any[]; title?: string; isNative?: boolean }) {
  if (banners?.length === 0) {
    return null;
  }

  return (
    <CarouselConteiner
      banners={banners}
      title={title}
      renderItem={(banner) => <BannerItem key={banner.name} banner={banner} isNative={isNative} />}
    />
  );
}

export function CarouselConteiner({ banners, title, renderItem }: BannerCarouselProps) {
  const [index, setIndex] = React.useState(0);

  const handlePrev = () => {
    setIndex((prevIndex) => (prevIndex === 0 ? banners.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setIndex((prevIndex) => (prevIndex === banners.length - 1 ? 0 : prevIndex + 1));
  };

  useEffect(() => {
    const interval = setInterval(handleNext, 4000);
    return () => clearInterval(interval);
  }, [index]);

  return (
    <VStack align={'self-start'} position="relative" spacing={2} width="100%">
      {title && (
        <Box padding="0px 20px">
          <Label>{title}</Label>
        </Box>
      )}
      <HStack position="relative" spacing={0} width="100%">
        <ButtonLabel onClick={handlePrev}>
          <ArrowLeft width={30} height={30} className="arrow-icon" />
        </ButtonLabel>
        <Box className="carousel-container" width="100%" overflow="hidden" position="relative">
          {banners.map((banner, i) => (
            <Box key={i} className={`carousel-item ${i === index ? 'active' : ''}`} width="100%">
              {renderItem(banner)}
            </Box>
          ))}
        </Box>

        <ButtonLabel padding={0} variant="plain" onClick={handleNext}>
          <ArrowRight width={30} height={30} className="arrow-icon" />
        </ButtonLabel>
      </HStack>
    </VStack>
  );
}
